<template>
  <cTable
    ref="table"
    :fields="fields"
    :modals="modals"
    :header="header"
    :methods="methods"
  >
  </cTable>
</template>

<script>
import { operSea } from "@/api/tracker/sea";
import cTable from "@/base/common/index";
export default {
  name: "sea",
  components: {
    cTable
  },
  async mounted() {},
  methods: {},
  data() {
    let statusList = [
      { label: "YES", value: "YES" },
      { label: "NO", value: "NO" }
    ];
    return {
      methods: {
        list: p => {
          console.log(p);

          p["method"] = p["method"] ? p["method"] : "get";
          return operSea(p);
        }
      },
      modals: {
        add: {
          methods: {
            ok({ row, close }) {
              row["method"] = row.id ? "PUT" : "POST";
              console.log(row);
              this.$page.handleRequestMethods("list", row, true).then(e => {
                this.$page.getList();
                close();
              });
            }
          },
          footer: {
            ok: {},
            cancel: {}
          },
          config: {
            modalBind: {
              width: 600
            },
            formBind: {
              labelWidth: 120
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              name: [
                {
                  required: true,
                  type: "string",
                  message: "name cannot be empty",
                  trigger: "blur"
                }
              ],
              code: [
                {
                  required: true,
                  type: "string",
                  message: "code cannot be empty",
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [{ name: 24 }, { code: 24 }],
          fields: [
            {
              key: "name",
              name: () => this.$t("ferryName"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("ferryName");
              }
            },
            {
              key: "code",
              name: () => this.$t("ferryCode"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("ferryCode");
              }
            }
            // {
            //   key: "country",
            //   name: () => this.$t("ownerCountry"),
            //   component: "Input",
            //   placeholder() {
            //     return this.$t("enter") + this.$t("ownerCountry");
            //   }
            // },
            // {
            //   key: "is_from",
            //   name: () => this.$t("startGang"),
            //   component: "Radio",
            //   bind: {
            //     border: true
            //   },
            //   options: statusList,
            //   default: "NO"
            // },
            // {
            //   key: "is_to",
            //   name: () => this.$t("endGang"),
            //   component: "Radio",
            //   bind: {
            //     border: true
            //   },
            //   options: statusList,
            //   default: "NO"
            // }
          ]
        }
      },
      header: {
        config: {
          custom: false
        },
        searchs: [
          // {
          //   key: "isUnique",
          //   placeholder() {
          //     return this.$t("select") + this.$t("is_unique");
          //   },
          //   component: "Select",
          //   options: statusList
          // },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            bind: {
              type: "textarea",
              rows: 1
            },
            component: "Input"
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "addFun",
              bind: {
                type: "warning",
                icon: "md-add"
              },
              id: 504
            }
          ],
          methods: {
            addFun({ field, searchForm }) {
              console.log(this);
              this.getModal("add").open(null, function() {
                this.setTitle(this.$t("add"));
              });
            }
          }
        }
      },
      fields: [
        {
          name: () => this.$t("ferryName"),
          key: "name",
          align: "center",
          minWidth: 150
        },
        {
          name: this.$t("ferryCode"),
          key: "code",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("createTime"),
          key: "create_time",
          align: "center",
          minWidth: 120,
          methods: {
            render({ value }) {
              return ~~value ? this.format.timeFormat(value * 1000) : "-";
            }
          }
        },
        {
          name: () => this.$t("upTime"),
          key: "update_time",
          align: "center",
          minWidth: 120,
          methods: {
            render({ value }) {
              return ~~value ? this.format.timeFormat(value * 1000) : "-";
            }
          }
        },
        {
          type: "btns",
          width: 200,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "updateFun",
              bind: {
                type: "success"
              },
              id: 503
            },
            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "deleteFun",
              bind: {
                type: "error"
              },
              id: 502
            }
          ],

          methods: {
            async updateFun({ row }) {
              let data = {
                methods: "get",
                id: row.id
              };
              let res = await this.handleRequestMethods("list", data);
              this.getModal("add").open(
                {
                  name: res.payload.name,
                  code: res.payload.code,
                  // country: res.payload.country,
                  // is_from: res.payload.is_from,
                  // is_to: res.payload.is_to,
                  id: row.id
                },
                function() {
                  this.setTitle(this.$t("update"));
                }
              );
            },
            deleteFun({ row }) {
              this.$Modal.confirm({
                title:
                  this.$t("whether") +
                  this.$t("confirm") +
                  this.$t("delete") +
                  this.$t("ferryName") +
                  "：" +
                  row.name +
                  "?",
                onOk: () => {
                  this.handleRequestMethods(
                    "list",
                    {
                      id: row.id,
                      method: "delete"
                    },
                    true
                  ).then(res => {
                    // this.$Message.success(res.data.msg);
                    this.getList();
                  });
                }
              });
            }
          }
        }
      ]
    };
  }
};
</script>
<style type="text/css">
/* @page{
    size: 7cm 8cm;
  } */
</style>
<style lang="scss" scoped></style>
